export default "__VITE_ASSET__3rRVaZJA__"